<template>
  <redoc-wrapper :spec="spec"/>
</template>

<script>
import RedocWrapper from '../../components/redoc-wrapper/redoc-wrapper.vue';
import { getSpec } from './spec';

export default {
  name: 'webhooks',
  components: {
    RedocWrapper,
  },
  data() {
    return {
      spec: null,
    };
  },
  methods: {
    async loadSpec(version) {
      this.spec = await getSpec(version);
    },
  },
  beforeRouteEnter(to, from, next) {
    return next(vm => vm.loadSpec(to.params.version));
  },
  beforeRouteUpdate(to, from) {
    return this.loadSpec(to.params.version);
  },
};
</script>
